/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.PurchaseOrder {
    angular.module("meevo.plugins.purchaseOrder", []);
}